module.exports = __webpack_public_path__ + "components/page-header/static/icon-user--grey-0d00971704774390b2459be53ff8764f.svg";